import * as React from "react";

interface DownArrowProps {
  color?: string;
  width?: string;
  height?: string; // Optional prop for height
}

const DownArrow: React.FC<DownArrowProps> = ({
  color = "#344054",
  width = "12",
  height = "12",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.5L5.29289 5.79289C5.62623 6.12623 5.79289 6.29289 6 6.29289C6.20711 6.29289 6.37377 6.12623 6.70711 5.79289L11 1.5"
        stroke={color} // Use the color prop for stroke
        strokeWidth="1.5" // Use camelCase for strokeWidth
        strokeLinecap="round" // Use camelCase for strokeLinecap
        strokeLinejoin="round" // Use camelCase for strokeLinejoin
        fill="none" // Fill should typically be "none" unless a color is specified
      />
    </svg>
  );
};

export { DownArrow };
